import wx from 'weixin-js-sdk'
import { getWxConfig } from '../request/api'
import store from '../store/index'

const ShareImpl = function (option, isHandleLoading) {
  return new Promise((resolve) => {
    // 获取当前的url
    const url = window.location.href.split('#')[0]

    const { shareTitle, shareDesc, shareUrl, shareImg } = option

    if (isHandleLoading) {
      store.commit('setLoadingStatus', true)
    }
    getWxConfig({
      url: encodeURIComponent(url),
      appId: 'wxdf259e4b545c6f2a'
    })
      .then((data) => {
        // 请求后台接口
        // console.log(data)
        store.commit('setLoadingStatus', false)
        if (data && data.data) {
          const { appId, timestamp, nonceStr, signature } = data.data

          // eslint-disable-next-line no-undef
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: appId, // 必填，公众号的唯一标识
            timestamp: timestamp, // 必填，生成签名的时间戳
            nonceStr: nonceStr, // 必填，生成签名的随机串
            signature: signature, // 必填，签名
            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
          })

          wx.ready(function () {
            //如果wx.config配置正常，会自动走此处
            // console.log('wx.ready执行完毕')

            // 自定义“分享给朋友”及“分享到QQ”按钮的分享内容
            // eslint-disable-next-line no-undef
            wx.updateAppMessageShareData({
              title: shareTitle, // 分享的标题
              desc: shareDesc, // 分享的描述信息
              link: shareUrl, // 分享的url
              imgUrl: shareImg, // 分享的图片
              success: function () {
                console.log('分享成功')
              },
              cancel: function () {
                console.log('取消分享')
              }
            })

            // 自定义“分享到朋友圈”及“分享到QQ空间”按钮的分
            // eslint-disable-next-line no-undef
            wx.updateTimelineShareData({
              title: shareTitle,
              desc: shareDesc,
              link: shareUrl,
              imgUrl: shareImg,
              success: function () {
                console.log('分享成功')
              },
              cancel: function () {
                console.log('取消分享')
              }
            })
          })

          wx.error(function (res) {
            // 如果wx.config配置失败,会走到此处
            console.log('wx.config配置获取失败，失败原因：', res)
          })

          resolve()
        }
      })
      .catch(() => {
        // 获取微信配置失败
        store.commit('setLoadingStatus', false)
      })
  })
}

export default ShareImpl
